<template>
  <div class="page-wrapper">
    <Title title="联系方式与合作"></Title>
    <div class="content">
      <!-- 联系方式 -->
      <div class="box" v-for="(item, index) in works" :key="index">
        <h1 class="title">{{ item.title }}</h1>
        <p class="name">
          姓名：{{ item.name }}
        </p>
        <p class="email">
          邮箱：{{ item.email }}
        </p>
        <img :src="item.qrcode" class="img" alt="">
      </div>

      <!-- SDK业务 -->
      <PageSdk />

      <!-- 公司的联系方式 -->
      <div class="contact-address">
        <p>地址:{{ info.address }}</p>
        <p>电话：{{ info.tel }}</p>
        <p>邮箱：{{ info.mail }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/mobile/Title'
import PageSdk from './components/pageSdk'

export default {
  name: 'MobileContact',
  components: {
    Title,
    PageSdk
  },
  data() {
    return {
      works: [
        {
          title: "移动APP广告合作",
          name: "王娇",
          email: "wangjiao@nineton.cn",
          qrcode: require('@/assets/img/pic_23.png')
        }],
      info: {}
    }
  },
  mounted() {
    this.getinfo()
  },
  methods: {

    async getinfo() {
      const [err, res] = await this.$http.get('info')
      if (err) return
      this.info = res
    },
  }

}
</script>

<style scoped lang="less">
.page-wrapper {
  position: relative;
  background: #FFF;
  padding: 1.76rem .5333rem 0 .5333rem;
  color: #000000;
  font-size: .2667rem;
  box-sizing: border-box;

  .content {


    .box {
      margin-bottom: 1rem;

      .title {
        font-size: .4rem;
        margin-bottom: .3333rem;
      }

      .name {
        font-size: .32rem;
        margin-bottom: .3333rem;
      }

      .email {
        font-size: .32rem;
        margin-bottom: .3rem;
      }

      .img {
        width: 1.52rem;
        height: 1.52rem;
      }
    }

    .contact-address {
      line-height: .7rem;
      font-size: .32rem;
    }
  }
}
</style>
